import React from "react";

export const PanelHeader = ({ children }) => <div className="mobile-collapse-list__panel-header">{children}</div>;
